import React, { useEffect } from 'react';
import '../../styles/PortraitLoading.css';

interface PortraitLoadingProps {
  message?: string;
}

const PortraitLoading: React.FC<PortraitLoadingProps> = ({ 
  message = "Loading..." 
}) => {
  useEffect(() => {
    // Force body styles when this component is mounted
    document.body.classList.add('portrait-loading-active');
    
    // Clean up when unmounted
    return () => {
      document.body.classList.remove('portrait-loading-active');
    };
  }, []);

  return (
    <div className="portrait-loading-container">
      <div className="portrait-loading-content">
        <div className="portrait-spinner"></div>
        {message && <p className="portrait-loading-message">{message}</p>}
      </div>
    </div>
  );
};

export default PortraitLoading; 